import React from "react";
import { Link } from "react-router-dom";
import tallyIcon from "../images/tally-relationship-icon1.png";
import "./SimplePage.scss";

interface SimplePageProps {
  title: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

const SimplePage: React.FC<SimplePageProps> = ({ title, lastUpdated, children }) => {
  return (
    <div className="simple-page">
      <header className="simple-page__header">
        <div className="simple-page__header-inner">
          <Link to="/" className="simple-page__brand">
            <img src={tallyIcon} alt="Tally" className="simple-page__brand-icon" />
            <span>Tally</span>
          </Link>
          <Link to="/" className="simple-page__back">← Back to home</Link>
        </div>
      </header>

      <main className="simple-page__main">
        <h1 className="simple-page__title">{title}</h1>
        {lastUpdated && (
          <div className="simple-page__updated">Last updated: {lastUpdated}</div>
        )}
        <div className="simple-page__body">{children}</div>
      </main>

      <footer className="simple-page__footer">
        <div className="simple-page__footer-inner">
          <span>© 2026 Tally. Made for Nigerian shop owners.</span>
          <div className="simple-page__footer-links">
            <Link to="/about">About</Link>
            <Link to="/privacy">Privacy policy</Link>
            <Link to="/help">Help centre</Link>
            <a href="mailto:hello@gettally.store">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SimplePage;